const styles = {
  global: {
    "*": {
      margin: 0,
      padding: 0,
      boxSizing: "border-box",
    },
    html: {
      width: "100%",
      height: "100%",
      WebkitOverflowScrolling: "touch",
    },
    body: {
      width: "100%",
      height: "100%",
    },
    "html, body": {
      color: "gray.500",
    },
    "#root": {
      width: "100%",
      height: "100%",
    },
  },
};

export default styles;
